import { useCreatePortfolioMutation } from '@/api/portfolioApi';
import {
  BIDDING_STRATEGY,
  OPTIMIZATION_STRATEGY,
  OPTIMIZATION_STRATEGY_OPTIONS,
} from '@/constants';
import { showSuccess } from '@/utils/messageService';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space } from 'antd';

const { Option } = Select;

const CreatePortfolio = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [createPortfolio, { isLoading }] = useCreatePortfolioMutation();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSubmit = async (values) => {
    // Map form values to API expected format
    const payload = {
      portfolioName: values.portfolio_name,
      isActive: values.status === 'Enabled',
      clv: values.clv,
      optimizationStrategy: values.optimizationStrategy,
      sparefootAccountId: parseInt(values.sparefootAccountId, 10),
    };

    try {
      await createPortfolio(payload).unwrap();
      showSuccess('Portfolio created successfully!');
      form.resetFields();
      onSuccess?.();
      onCancel();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      title={
        <Space>
          <PlusOutlined />
          Create Portfolio
        </Space>
      }
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          status: 'Enabled',
          clv: 12,
          biddingStrategy: BIDDING_STRATEGY.FACILITY_MAX_BID,
          optimizationStrategy: OPTIMIZATION_STRATEGY.NEIGHBOR_QUE,
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Portfolio Name"
              name="portfolio_name"
              rules={[{ required: true, message: 'Portfolio Name is required' }]}
            >
              <Input placeholder="Enter portfolio name" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Sparefoot Account ID"
              name="sparefootAccountId"
              rules={[{ required: true, message: 'Sparefoot Account ID is required' }]}
            >
              <Input placeholder="Enter Sparefoot Account ID" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: 'Status is required' }]}
            >
              <Select>
                <Option value="Enabled">Enabled</Option>
                <Option value="Disabled">Disabled</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="LOS (months)"
              name="clv"
              rules={[{ required: true, message: 'LOS is required' }]}
            >
              <InputNumber min={1} max={120} style={{ width: '100%' }} placeholder="Enter LOS" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Optimization Strategy"
              name="optimizationStrategy"
              rules={[{ required: true, message: 'Optimization Strategy is required' }]}
            >
              <Select options={OPTIMIZATION_STRATEGY_OPTIONS} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end" gutter={[8, 8]} style={{ marginTop: 24 }}>
          <Col>
            <Button onClick={handleCancel} disabled={isLoading}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Create Portfolio
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CreatePortfolio;
